// extracted by mini-css-extract-plugin
export default {"WishButton":"WishButton_WishButton__4UORR"};